export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-10 text-center">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 mx-auto mb-4">
              <i className="ri-shield-star-line text-xl"></i>
            </span>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
              Your Safety Comes First
            </h2>
            <p className="text-foreground-600 text-xs md:text-sm leading-relaxed mb-5">
              We provide educational resources only. We are an independent platform and do not guarantee product authenticity, seller performance, shipping outcomes, or third-party services. Users should always perform their own research before making purchasing decisions.
            </p>
            <p className="text-foreground-500 text-xs italic">
              This is an independent educational resource platform. Not affiliated with any official Superbuy entity.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}